exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__value___3SacC {\n  font-size: 13px;\n  color: #828282; }\n", ""]);

// exports
exports.locals = {
	"value": "style__value___3SacC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/SimilarAdCard/AdSummary/DateAndLocation/style.scss
// module id = 4137
// module chunks = 6